// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import StoreStaticMap from '@tcp/core/src/components/common/atoms/StoreStaticMap';
import StoreStaticMapGmaps from '@tcp/core/src/components/common/atoms/StoreStaticMap/views/StoreStaticMapGmaps';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import StoreAddressTile from '@tcp/core/src/components/common/molecules/StoreAddressTile';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import SeoCopy from '@tcp/core/src/components/features/browse/ProductListing/molecules/SeoCopy/views';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import {
  isCanada,
  getViewportInfo,
  getAPIConfig,
  routeToStoreDetails,
  isGymboree,
} from '@tcp/core/src/utils';
import { CALL_TO_ACTION_VISIBLE, FULLY_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import StoreLocatorSearch from '../../organisms/StoreSearch';
import StoreDetailContainerClass from '../../../StoreDetail/container/StoreDetail.container';

import styles from '../styles/StoreLanding.style';
import { filterStores } from '../utils/userFavStore';
import {
  STORE_DETAILS_LABELS,
  STORE_LANDING_LABELS,
  STORE_LIST_LABELS,
  StoreLocatorLabels,
  lblStorelandingErrorLabel,
  lblStorelandingFavStoreHeading,
  lblStorelandingNoStoresFound,
} from '../../../Labels/StoreLocator.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblCancelCaps,
} from '../../../../../../utils/labels/globalActions.labels';

export class StoreLanding extends PureComponent {
  labels = {
    ...getLabelFromCopyOrFromTranslation(STORE_DETAILS_LABELS, StoreLocatorLabels),
    ...getLabelFromCopyOrFromTranslation(STORE_LANDING_LABELS, StoreLocatorLabels),
    ...getLabelFromCopyOrFromTranslation(STORE_LIST_LABELS, StoreLocatorLabels),
  };

  globalActions = getLabelFromCopyOrFromTranslation(GLOBAL_ACTIONS_LABELS, GlobalActionsLabels);

  constructor(props) {
    super(props);
    this.state = {
      mapView: false,
      isOutlet: false,
      isGym: isGymboree(),
      centeredStoreId: '',
      showSubmitError: false,
      mapImageHasLoaded: false,
      hasMounted: false,
    };
  }

  componentDidMount() {
    const { pageData, User, APIConfig, session } = this.props;
    this.setState({ hasMounted: true });
    pushEventToAdobeAnalytics('page_view', { pageData, User, APIConfig, session });
  }

  openStoreDetails = (event, store) => {
    event.preventDefault();
    setTimeout(() => {
      const { routerHandler } = routeToStoreDetails(store);
      routerHandler();
    }, 0);
  };

  focusOnMap = (event, id) => {
    event.preventDefault();
    this.setState({
      centeredStoreId: id,
    });
  };

  handleMapImageLoaded = () => {
    this.setState({
      mapImageHasLoaded: true,
    });
  };

  renderMapView = (suggestedStoreList) => {
    const { setFavoriteStore, favoriteStore, searchDone, mapboxSwitch, ...others } = this.props;
    const { centeredStoreId, showSubmitError } = this.state;

    const showNotification =
      showSubmitError ||
      (searchDone &&
        !(suggestedStoreList && (suggestedStoreList.length || suggestedStoreList.size)));

    let StoreStaticMapCommon = StoreStaticMap;
    let apiKey = getAPIConfig().mapBoxApiKey;
    if (!mapboxSwitch) {
      StoreStaticMapCommon = StoreStaticMapGmaps;
      apiKey = getAPIConfig().googleApiKey;
    }

    const storeList = showNotification ? (
      <Notification
        status={showSubmitError ? 'error' : 'info'}
        message={
          showSubmitError
            ? renderLabel(this.labels[lblStorelandingErrorLabel], lblStorelandingErrorLabel)
            : renderLabel(this.labels[lblStorelandingNoStoresFound], lblStorelandingNoStoresFound)
        }
        className="storeview__error"
      />
    ) : (
      suggestedStoreList.map((item, index) => (
        <Col
          colSize={{ large: 12, medium: 8, small: 6 }}
          ignoreGutter={{ small: true }}
          className="store_item_container"
        >
          <StoreAddressTile
            {...this.props}
            className="storelocator__tile"
            store={item}
            variation="listing"
            storeIndex={index + 1}
            setFavoriteStore={setFavoriteStore}
            isFavorite={favoriteStore && favoriteStore.basicInfo.id === item.basicInfo.id}
            key={item.basicInfo.id}
            openStoreDetails={this.openStoreDetails}
            titleClickCb={this.focusOnMap}
            selectedStoreId={centeredStoreId === item.basicInfo.id}
          />
        </Col>
      ))
    );

    const storeMap = (
      <Col colSize={{ large: 12, medium: 8, small: 6 }} ignoreGutter={{ small: true }}>
        <StoreStaticMapCommon
          storesList={suggestedStoreList}
          isCanada={isCanada()}
          isMobile={getViewportInfo().isMobile}
          apiKey={apiKey}
          labels={this.labels}
          centeredStoreId={centeredStoreId}
          onImageLoad={this.handleMapImageLoaded}
          {...others}
        />
      </Col>
    );

    return (
      <>
        <Col
          colSize={{ large: 6, medium: 4, small: 6 }}
          ignoreGutter={{ small: true }}
          className="store__map"
        >
          <Row fullBleed>{storeMap}</Row>
        </Col>
        <Col
          colSize={{ large: 12, medium: 4, small: 6 }}
          ignoreGutter={{ small: true }}
          className="storeList__map"
          ignoreNthRule
        >
          <Row fullBleed>{storeList}</Row>
        </Col>
      </>
    );
  };

  renderStoreList = (suggestedStoreList) => {
    const { centeredStoreId, showSubmitError } = this.state;
    const { setFavoriteStore, favoriteStore, openStoreDirections, searchDone, geoLocationEnabled } =
      this.props;
    if (
      showSubmitError ||
      (searchDone &&
        !(suggestedStoreList && (suggestedStoreList.length || suggestedStoreList.size)))
    ) {
      return (
        <Notification
          status={showSubmitError ? 'error' : 'info'}
          message={
            showSubmitError
              ? renderLabel(this.labels[lblStorelandingErrorLabel], lblStorelandingErrorLabel)
              : renderLabel(this.labels[lblStorelandingNoStoresFound], lblStorelandingNoStoresFound)
          }
          className="storeview__error"
        />
      );
    }
    return suggestedStoreList.map((item, index) => (
      <Col
        colSize={{ large: 12, medium: 4, small: 6 }}
        ignoreGutter={{ small: true }}
        className="store__list store_item_container"
        key={item.basicInfo.id}
      >
        <StoreAddressTile
          {...this.props}
          className="storelocator__tile"
          store={item}
          variation="listing"
          setFavoriteStore={setFavoriteStore}
          isFavorite={favoriteStore && favoriteStore.basicInfo.id === item.basicInfo.id}
          openStoreDirections={openStoreDirections}
          openStoreDetails={this.openStoreDetails}
          storeIndex={!!getViewportInfo().isDesktop && index + 1}
          titleClickCb={this.focusOnMap}
          selectedStoreId={centeredStoreId === item.basicInfo.id}
          geoLocationDisabled={!geoLocationEnabled}
        />
      </Col>
    ));
  };

  renderFavoriteStore = () => {
    const { favoriteStore, geoLocationEnabled, userStoreId } = this.props;
    const { hasMounted } = this.state;
    return (
      <>
        {hasMounted && favoriteStore && (
          <Row className="favoriteStore__container">
            <Col
              colSize={{ large: 12, medium: 8, small: 6 }}
              ignoreGutter={{ small: true }}
              className="store_item_container"
            >
              <p className="favoriteStore__heading">
                {renderLabel(
                  this.labels[lblStorelandingFavStoreHeading],
                  'lbl_storelanding_favStoreHeading'
                )}
              </p>
              <StoreAddressTile
                {...this.props}
                className="storelocator__tiles"
                store={favoriteStore}
                variation="listing-header"
                isFavorite
                openStoreDetails={this.openStoreDetails}
                geoLocationDisabled={!geoLocationEnabled}
                userStoreId={userStoreId}
              />
            </Col>
          </Row>
        )}
      </>
    );
  };

  toggleMap = (event) => {
    event.preventDefault();
    this.setState((prevState) => ({
      mapView: !prevState.mapView,
    }));
  };

  selectStoreType = ({ gymSelected, outletSelected }) => {
    this.setState({
      isGym: gymSelected,
      isOutlet: outletSelected,
    });
  };

  showSubmitError = (value) => {
    const { showSubmitError } = this.state;
    if (showSubmitError !== value) this.setState({ showSubmitError: value });
  };

  render() {
    const {
      className,
      suggestedStoreList,
      loadStoresByCoordinates,
      searchIcon,
      markerIcon,
      getLocationStores,
      setClickAnalyticsData,
      trackClick,
      trackPageLoad,
      isGeoCodeAPIEnabled,
      seoData,
      mapboxStoreSearchTypesParam,
      mapboxSwitch,
      ...others
    } = this.props;
    const { mapView, isGym, isOutlet, centeredStoreId, mapImageHasLoaded, hasMounted } = this.state;

    const modifiedStoreList = filterStores(suggestedStoreList, isOutlet, isGym);

    let StoreStaticMapCommon = StoreStaticMap;
    let apiKey = getAPIConfig().mapBoxApiKey;
    if (!mapboxSwitch) {
      StoreStaticMapCommon = StoreStaticMapGmaps;
      apiKey = getAPIConfig().googleApiKey;
    }

    return (
      <>
        <Anchor
          fontSizeVariation="xlarge"
          anchorVariation="secondary"
          handleLinkClick={StoreDetailContainerClass.routesBack}
          noLink
          className={`${className}__backlink`}
          title={renderLabel(this.globalActions[lblCancelCaps], 'lbl_cancel_caps')}
        >
          <span className="left-arrow" />
          {renderLabel(this.globalActions[lblCancelCaps], 'lbl_cancel_caps')}
        </Anchor>
        <Grid className={className}>
          <Row fullBleed>
            <Col colSize={{ large: 6, medium: 8, small: 6 }} ignoreGutter={{ small: true }}>
              {this.renderFavoriteStore()}
              <Row fullBleed>
                <Col colSize={{ large: 12, medium: 8, small: 6 }} ignoreGutter={{ small: true }}>
                  <StoreLocatorSearch
                    labels={this.labels}
                    loadStoresByCoordinates={loadStoresByCoordinates}
                    toggleMap={this.toggleMap}
                    mapView={mapView}
                    selectStoreType={this.selectStoreType}
                    searchIcon={searchIcon}
                    markerIcon={markerIcon}
                    getLocationStores={getLocationStores}
                    showSubmitError={this.showSubmitError}
                    setClickAnalyticsData={setClickAnalyticsData}
                    trackClick={trackClick}
                    trackPageLoad={trackPageLoad}
                    selectedCountry={isCanada() ? 'CA' : 'USA'}
                    isGeoCodeAPIEnabled={isGeoCodeAPIEnabled}
                    mapboxStoreSearchTypesParam={mapboxStoreSearchTypesParam}
                    mapboxSwitch={mapboxSwitch}
                  />
                  {/* UX Timer */}
                  <RenderPerf.Measure name={CALL_TO_ACTION_VISIBLE} />
                </Col>
              </Row>
              <Row
                className={`storeView__List${mapView ? ' storeView__ListAndMap' : ''}`}
                fullBleed
                aria-live="polite"
                noLastMargin
              >
                {mapView
                  ? this.renderMapView(modifiedStoreList)
                  : this.renderStoreList(modifiedStoreList)}
              </Row>
            </Col>
            <Col
              colSize={{ large: 6, medium: 8, small: 6 }}
              ignoreGutter={{ small: true }}
              className="mapView__desktop"
            >
              <StoreStaticMapCommon
                storesList={modifiedStoreList}
                isCanada={isCanada()}
                apiKey={apiKey}
                centeredStoreId={centeredStoreId}
                onImageLoad={this.handleMapImageLoaded}
                {...others}
              />
            </Col>
          </Row>
          {/* UX Timer */}
          {hasMounted && mapImageHasLoaded && <RenderPerf.Measure name={FULLY_VISIBLE} />}
        </Grid>
        <SeoCopy {...seoData} />
      </>
    );
  }
}

StoreLanding.propTypes = {
  fetchStoresByCoordinates: PropTypes.func.isRequired,
  suggestedStoreList: PropTypes.arrayOf({}),
  setFavoriteStore: PropTypes.func.isRequired,
  favoriteStore: PropTypes.shape(PropTypes.string),
  className: PropTypes.string.isRequired,
  openStoreDirections: PropTypes.func.isRequired,
  loadStoresByCoordinates: PropTypes.func.isRequired,
  markerIcon: PropTypes.string.isRequired,
  searchIcon: PropTypes.string.isRequired,
  getLocationStores: PropTypes.func.isRequired,
  searchDone: PropTypes.bool,
  geoLocationEnabled: PropTypes.bool,
  setClickAnalyticsData: PropTypes.func.isRequired,
  trackClick: PropTypes.func.isRequired,
  trackPageLoad: PropTypes.func.isRequired,
  isGeoCodeAPIEnabled: PropTypes.bool.isRequired,
  userStoreId: PropTypes.string,
  seoData: PropTypes.shape({}),
  mapboxStoreSearchTypesParam: PropTypes.string,
  mapboxSwitch: PropTypes.bool,
  router: PropTypes.shape({}).isRequired,
};

StoreLanding.defaultProps = {
  suggestedStoreList: [],
  favoriteStore: null,
  searchDone: false,
  geoLocationEnabled: false,
  userStoreId: '',
  seoData: {},
  mapboxStoreSearchTypesParam: '',
  mapboxSwitch: true,
};

const StoreLandingStyled = errorBoundary(withStyles(StoreLanding, styles), 'StoreLanding');

export default withRouter(StoreLandingStyled);

export { StoreLanding as StoreLandingVanilla };
